export default {
    name: 'thumbtack-search',
    emits: ['update:modelValue'],
    props: {
        modelValue: {type: Object, default: null},
    },
    computed: {
        query: {
            get() {
                if (!this.modelValue) return null;
                return this.modelValue.query;
            },
            set(value) {
                const payload = this.modelValue || {};
                this.$emit('update:modelValue', {...payload, query: value});
            },
        },
        zipCode: {
            get() {
                if (!this.modelValue) return null;

                return this.modelValue.zipCode;
            },
            set(value) {
                const payload = this.modelValue || {};
                this.$emit('update:modelValue', {...payload, zipCode: value});
            },
        },
    },
};
